"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
const react_1 = require("react");
const useClickOutside = (triggerRef, callback) => {
    const [, _setIsAdded] = (0, react_1.useState)(false);
    const handleClick = (0, react_1.useCallback)((event) => {
        var _a;
        const doesTriggerContain = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target);
        const isTriggerAndTargetSame = triggerRef.current === (event === null || event === void 0 ? void 0 : event.target);
        if (!isTriggerAndTargetSame && !doesTriggerContain) {
            callback();
        }
    }, [triggerRef, callback]);
    (0, react_1.useEffect)(() => {
        _setIsAdded((prevState) => {
            if (prevState) {
                // eslint-disable-next-line no-console
                console.warn("`useClickOutside` was already added to document! Please check if you don't pass unwrapped callback!");
            }
            return true;
        });
        document.addEventListener('click', handleClick);
        document.addEventListener('contextmenu', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('contextmenu', handleClick);
        };
    }, [handleClick]);
};
exports.useClickOutside = useClickOutside;
